import connectRequestApi from '../../repos/tradera-store-connect-request'
const TRADERA_STORAGE_KEY = 'conn_req_tradera';
const CONN_REQ_STORAGE_KEY = 'conn_req';

const state = {
    tradera: JSON.parse(localStorage.getItem(TRADERA_STORAGE_KEY)),
    connectRequest: JSON.parse(localStorage.getItem(CONN_REQ_STORAGE_KEY))
};

const actions = {
    beginConnect({ state, commit }, traderaUser) {
        return connectRequestApi.post(traderaUser)
            .then(response => {
                commit('beginConnectSuccess', response.data);
            })
        ;
    },
    finalizeConnect({ state, commit }) {
        return connectRequestApi.put(state.connectRequest.id)
            .then(response => {
                commit('finalizeConnectSuccess', response.data);
                commit('traderaStores/resetFetchTime', null, { root: true });
            })
        ;
    }
};

const mutations = {
    beginConnectSuccess(state, { tradera, connect_request }) {
        state.tradera = tradera;
        state.connectRequest = connect_request;
        localStorage.setItem(TRADERA_STORAGE_KEY, JSON.stringify(tradera));
        localStorage.setItem(CONN_REQ_STORAGE_KEY, JSON.stringify(connect_request));
    },
    finalizeConnectSuccess(state) {
        state.tradera = null;
        state.connectRequest = null;
        localStorage.removeItem(TRADERA_STORAGE_KEY);
        localStorage.removeItem(CONN_REQ_STORAGE_KEY);
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
